import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, HighlightedText } from '@adv-frontend/filters';
import { trimAndLowerString } from '#shared/lib/string';
import { useCharacteristicsGetAll } from '../../api';
import { CHARACTERISTIC_FILTER_ID } from '../constants/characteristicFilter';
import { useFilterCharacteristicTitleByValue } from '../hooks/useFilterCharacteristicTitleByValue';

export const CHARACTERISTIC_FILTER_TITLE = 'Характеристика';

type CharacteristicRowData = {
    id: string;
    label: string;
};

export const createCharacteristicFilter = () =>
    createFilterSelectWithSuggest<string, CharacteristicRowData>({
        id: CHARACTERISTIC_FILTER_ID,
        title: CHARACTERISTIC_FILTER_TITLE,
        suggestProps: {
            dataProvider: function Component(props) {
                const { data } = useCharacteristicsGetAll({});
                const searchString = trimAndLowerString(props.queryArg.searchValue);

                const mappedData = useMemo<CharacteristicRowData[]>(
                    () =>
                        data
                            ?.filter(({ title }) => trimAndLowerString(title).includes(searchString))
                            .map((item) => {
                                return {
                                    id: item.slug,
                                    label: item.title,
                                };
                            }) ?? [],
                    [data, searchString]
                );

                const dataProvider = useMemo(() => createStaticDataProvider(mappedData), [mappedData]);

                return props.children(dataProvider);
            },
            useTitleByValue: useFilterCharacteristicTitleByValue,
            renderSelectListItem: ({ item, search }) => <HighlightedText text={item.label} search={search} joinParts />,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
